var render = function render(){var _vm=this,_c=_vm._self._c;return _c('welfare-lottery',{attrs:{"welfare-lottery-sdk":_vm.welfareLotterySdk,"watch-url":_vm.watchUrl,"lang":_vm.lang},on:{"entry-visible-changed":_vm.onEntryVisibleChanged,"lotteryCallback":_vm.lotteryCallback}})
}
var staticRenderFns = []

export { render, staticRenderFns }